
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import './App.css';

import NavBar               from './components/NavBar';

import { PushNotificationsProvider } from './contexts/PushNotificationsContext';
import { FarolProvider }             from './contexts/FarolPageContext';
import { BackOfficeProvider }        from './contexts/BackOfficeContext';
import { JustificationPageProvider } from './contexts/JustificationPageContext';

import PushNotifications            from './components/PushNotifications';

import axios                        from 'axios';

import LoginPage                    from './pages/LoginPage';
import HomePage                     from './pages/HomePage';
import FarolDashboardPage           from './pages/FarolDashboardPage';
import FarolManagePage              from './pages/FarolManagePage';
import InputFilePage                from './pages/InputFilePage';
import BackOfficePage               from './pages/BackOfficePage';
import JustificationPage            from './pages/JustificationPage';
import PxoPage                      from './pages/PxoPage';
import SimulationAnylogicPage       from './pages/SimulationAnylogicPage'
import MassBalancePage             from './pages/MassBalancePage'
import ShiftChangePage              from './pages/ShiftChangePage'
import TrainQueuePage               from './pages/TrainQueuePage'
import Gantt                        from './components/GoogleCharts/Gantt'

import { InputFilePageProvider }    from './contexts/InputFilePageContext';
import { UserProvider }             from './contexts/UserContext';
import { PxoPageProvider }          from './contexts/PxoPageContext';
import { PxoTableProvider }         from "./contexts/PxoTableContext";
import { MassBalancePageProvider }  from './contexts/MassBalancePageContext';

const baseURL = process.env.REACT_APP_API_URL || 'http://localhost:5000';
axios.defaults.baseURL = baseURL;

function App() {

    return (
        <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <UserProvider>
                <Routes>
        
                <Route 
                        path="/"                   
                        element={<LoginPage />} 
                />
                    <Route 
                        path="/home"               
                        element={
                            <>
                                <NavBar /> 
                                <PushNotificationsProvider>
                                    <HomePage />
                                    <PushNotifications />
                                </PushNotificationsProvider>
                            </>
                        } 
                    />  
                    <Route 
                        path="/farol/dashboard"    
                        element={
                            <>
                                <NavBar />         
                                
                                <PushNotificationsProvider>
                                    <FarolProvider>
                                        <PushNotifications />
                                        <FarolDashboardPage />
                                    </FarolProvider>
                                </PushNotificationsProvider> 
                            </>
                        } 
                    />  
                    <Route 
                        path="/farol/manage"       
                        element={
                            <>
                                <NavBar />

                                <PushNotificationsProvider>
                                    <FarolProvider>
                                        <PushNotifications />
                                        <FarolManagePage />
                                    </FarolProvider>
                                </PushNotificationsProvider> 
                            </>
                        } 
                    />

                    <Route 
                        path="/pxo"       
                        element={
                            <>
                                <NavBar />  

                                <PushNotificationsProvider>
                                    <PxoPageProvider>
                                        <PxoTableProvider>

                                            <PushNotifications />
                                            <PxoPage/>

                                        </PxoTableProvider>
                                    </PxoPageProvider> 
                                </PushNotificationsProvider>
                            </>
                        } 
                    />

                    <Route 
                        path="/backoffice"       
                        element={
                            <>
                                <NavBar />

                                <PushNotificationsProvider>
                                <BackOfficeProvider>

                                    <PushNotifications />
                                    <BackOfficePage />

                                </BackOfficeProvider> 
                                </PushNotificationsProvider>
                            </>
                        } 
                    />
                    <Route 
                        path='/inputFile'              

                        element={
                        <>
                            <NavBar /> 
                            <PushNotificationsProvider>                        
                                <InputFilePageProvider>

                                    <InputFilePage >
                                        <PushNotifications />
                                    </InputFilePage >

                                </InputFilePageProvider>
                            </PushNotificationsProvider>

                        </> } 
                    />
                    
                    <Route
                        path='/justificationPage'
                        element={
                            <>
                                
                                <NavBar /> 

                                <PushNotificationsProvider>
                                    
                                    <JustificationPageProvider>
                                        
                                        <JustificationPage />

                                    </JustificationPageProvider>

                                </PushNotificationsProvider>
                            </>
                            }
                    />

                    <Route
                        path='/simulationAnylogicPage'
                        element={
                            <>
                                <NavBar />
                                <SimulationAnylogicPage />
                            </>
                        }
                            



                    />
                
                    <Route
                        path='/MassBalancePage'
                        element={
                            <>
                                <NavBar />
                                <MassBalancePageProvider>
                                    <MassBalancePage />
                                </MassBalancePageProvider>
                            </>
                        }
                            



                    />

                

                    <Route
                        path='/shiftChangePage'
                        element={
                            <>
                                <NavBar />
                                <ShiftChangePage />
                            </>
                        }
                    />

                    <Route
                        path='/trainQueuePage'
                        element={
                            <>
                                <NavBar />
                                <TrainQueuePage />
                            </>
                        }
                    />

                    <Route
                        path='/__gantt_test'
                        element={
                            <div style={{ padding: 40, maxWidth: 900 }}>
                                <Gantt
                                    loading={false}
                                    data={[
                                        { ship: 'Navio Alpha', date: '2026-09-01' },
                                        { ship: 'Navio Alpha', date: '2026-09-05' },
                                        { ship: 'Navio Beta com Nome Bem Comprido', date: '2026-09-03' },
                                        { ship: 'Navio Beta com Nome Bem Comprido', date: '2026-09-08' },
                                        { ship: 'Navio Gamma', date: '2026-09-06' },
                                        { ship: 'Navio Gamma', date: '2026-09-10' }
                                    ]}
                                />
                            </div>
                        }
                    />

                </Routes>
                </UserProvider>
        </Router>
    )

}

export default App;
